import { Stack, Table } from '@mantine/core';

import { AbstractCount } from '@/module/AnnualReport/components/AbstractCount';
import { ArticleCount } from '@/module/AnnualReport/components/ArticleCount';
import { TextCount } from '@/module/AnnualReport/components/TextCount';
import { AnnualReportOverviewCount } from '@/module/AnnualReport/model/AnnualReportTypes';

import { Content } from '@/core/components';

interface ReportCountBoxProps {
  overview: AnnualReportOverviewCount;
}

export function ReportCountBox({ overview }: ReportCountBoxProps) {
  const { patentsCount, awardsCount, technologicalTransfersCount } = overview;
  return (
    <Stack>
      <ArticleCount overview={overview} />
      <AbstractCount overview={overview} />
      <TextCount overview={overview} />
      <Content type="full">
        <Table variant="vertical">
          <Table.Tbody>
            <Table.Tr>
              <Table.Th w="80%">Premii</Table.Th>
              <Table.Td>{awardsCount}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Brevete / Produse cu drept de proprietate intelectuală</Table.Th>
              <Table.Td>{patentsCount}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Transferuri tehnologice</Table.Th>
              <Table.Td>{technologicalTransfersCount}</Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Content>
    </Stack>
  );
}
